export const NAVBAR_ID = 'navbar';

export const enum NavbarShortcut {
  CmdK = 'cmd-k',
  CtrK = 'ctr-k',
}
